import { useState } from "react";
import { Formik, Form } from "formik";
import useTutorial from "../../../hooks/useTutorial";
import InputRange from "../../../components/input-range";
import { BaSeIcon, BaSeGrid, BaSeGridItem } from "@base/react";
import TitleWithPopover from "../../../components/title-with-popover";

const TutorialReceiptDeadline = () => {
  const [form] = useState([
    { order: 0, value: 0 },
    { order: 1, value: 0 },
    { order: 2, value: 0 },
    { order: 3, value: 0 },
    { order: 4, value: 0 },
    { order: 5, value: 0 },
  ]);
  const [dataPlanning] = useState(2);

  const PAGE_KEY = "prazosDeRecebimento";

  useTutorial({
    pageKey: "prazosDeRecebimento",
    previousKey: "investimentoTotal",
    currentStep: "11",
    steps: [
      {
        element: ".receipt-deadline",
        popover: {
          title: "Prazos de Recebimento",
          description: `Gerencie melhor seu fluxo de caixa! Defina os prazos de recebimento de vendas para manter a 
          previsibilidade financeira do seu negócio. Lembre-se de que a soma dos percentuais deve totalizar 100% 
          para manter o equilíbrio financeiro.`,
          side: "bottom",
          align: "center",
        },
        onHighlighted: () => {
          const sideBar = document.querySelector(".list-menu");
          if (sideBar) {
            sideBar.classList.remove("open");
          }
        },
      },
    ],
    onNextButtonClick: (driverObj) => {
      const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};

      if (tutorials["prazosDePagamento"]) {
        tutorials["prazosDePagamento"].finalizado = false;
      }

      tutorials[PAGE_KEY] = { ...tutorials[PAGE_KEY], finalizado: true };
      localStorage.setItem("tutorials", JSON.stringify(tutorials));

      const botaoProx = document.querySelector("#botaoSeguirTutorial button");
      botaoProx.click();
      driverObj.drive(0);
    },
  });

  return (
    <div translate="no" className="step receipt-deadline">
      <TitleWithPopover
        title="Prazos de Recebimento"
        titlePopover="% da Receita"
        messagePopover="A soma dos percentuais lançados DEVE SER IGUAL a 100%."
        size={5}
      />

      <Formik>
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className="group-input desktop">
              <BaSeGrid>
                {form.slice(0, 2).map(({ order, value }) => {
                  let label =
                    order === 0
                      ? "Recebimento à vista"
                      : "Recebimento em 30 dias";

                  return (
                    <BaSeGridItem
                      key={order}
                      desktop={{
                        size: 6,
                        startAt: undefined,
                      }}
                    >
                      <div className="group-input mobile">
                        <InputRange isDisabled label={label} value={value} />
                      </div>
                    </BaSeGridItem>
                  );
                })}
              </BaSeGrid>
            </div>

            <div className="installments">
              <BaSeGrid>
                {form.slice(2, form.length).map(({ order, value }) => {
                  let label = `Recebimento em ${order}x`;

                  return (
                    <BaSeGridItem
                      key={order}
                      desktop={{
                        size: 6,
                        startAt: undefined,
                      }}
                    >
                      <InputRange isDisabled label={label} value={value} />
                    </BaSeGridItem>
                  );
                })}
              </BaSeGrid>

              {form.length <= 12 && !dataPlanning?.is_finished ? (
                <button
                  type="button"
                  className="btn-without-style btn-add-more"
                  // onClick={addField}
                >
                  <BaSeIcon
                    color="#005EB8"
                    description="Adicionar"
                    name="plus-square"
                    size={24}
                  />
                </button>
              ) : (
                ""
              )}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TutorialReceiptDeadline;
